import React, { useState } from 'react';
import styles from './HelpModal.module.scss';

const AigulIcon = () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(12,12)">
            <path d="M0-2Q2-5,0-8Q-2-5,0-2Z"/>
            <path d="M0-2Q2-5,0-8Q-2-5,0-2Z" transform="rotate(72)"/>
            <path d="M0-2Q2-5,0-8Q-2-5,0-2Z" transform="rotate(144)"/>
            <path d="M0-2Q2-5,0-8Q-2-5,0-2Z" transform="rotate(216)"/>
            <path d="M0-2Q2-5,0-8Q-2-5,0-2Z" transform="rotate(288)"/>
            <circle cx="0" cy="0" r="1.8"/>
            <path d="M0 2Q-0.8 5,-0.8 8L0.8 8Q0.8 5,0 2Z"/>
        </g>
    </svg>
);

const SECTIONS = [
    {
        id: 'overview',
        title: 'Обзор',
        description: 'Что такое NcoreHub и как он работает',
        items: [
            {
                heading: 'Что такое NcoreHub?',
                body: 'NcoreHub — персональная система управления репозиториями для Ncore. Полный аналог GitHub с поддержкой CLI-команд через утилиту ncore. Храните код, документацию и историю изменений в одном месте.',
            },
            {
                heading: 'Публичные и приватные репозитории',
                body: 'Публичные репозитории видны всем посетителям сайта без авторизации.\nПриватные — только владельцу и коллаборативам. Для работы с приватными всегда требуется вход в аккаунт.',
            },
            {
                heading: 'Что доступно без авторизации',
                body: 'Просмотр публичных репозиториев, файлов, веток, Issues, PR, релизов, Wiki и аналитики.',
            },
            {
                heading: 'Что требует авторизации',
                body: 'Создание репозиториев, Issues и PR, написание комментариев, постановка звёзд (⭐), создание форков, управление коллаборативами и вики-страницами.',
            },
        ],
    },
    {
        id: 'repos',
        title: 'Репозитории',
        description: 'Создание и управление репозиториями',
        items: [
            {
                heading: 'Создать репозиторий',
                body: 'Нажмите «+ Новый репозиторий» в шапке страницы NcoreHub. Заполните форму: имя, описание, видимость, основная ветка, темы (topics), ссылка на сайт.',
            },
            {
                heading: 'Название и slug',
                body: 'Имя репозитория автоматически преобразуется в slug для URL.\nПример: «My API Project» → my-api-project\nURL репозитория будет: /ncoreboard/ваш_логин/my-api-project',
            },
            {
                heading: 'Темы (topics)',
                body: 'Добавляйте теги через запятую при создании или редактировании репозитория.\nПример: python, django, api, backend\nПомогают классифицировать и найти нужный репозиторий.',
            },
            {
                heading: 'Форк репозитория',
                body: 'Кнопка «Fork» в шапке репозитория создаёт копию в вашем аккаунте. Форк сохраняет ссылку на оригинальный репозиторий. Используйте для экспериментов без влияния на оригинал.',
            },
            {
                heading: 'Архивирование',
                body: 'Кнопка «Archive» (в шапке для владельца) переводит репозиторий в режим только для чтения. Создание Issues, PR, коммитов и изменение Wiki будут заблокированы.',
            },
            {
                heading: 'Звёзды и наблюдение',
                body: '⭐ Звезда — добавить репозиторий в «Избранные» (фильтр на главной странице).\n👁 Watch — подписка на уведомления об изменениях.',
            },
        ],
    },
    {
        id: 'cli',
        title: 'CLI команды',
        description: 'Работа через командную строку ncore',
        items: [
            {
                heading: 'Установка и клонирование',
                body: 'ncore clone https://security.ncore.kg/ncoreboard/owner/repo.git\n\nСкачивает полный репозиторий с историей коммитов на ваш компьютер.',
                code: true,
            },
            {
                heading: 'Базовый рабочий цикл',
                body: 'ncore status               — посмотреть изменения\nncore add .               — добавить все изменённые файлы\nncore add src/file.js     — добавить конкретный файл\nncore commit -m "feat: добавить авторизацию"\nncore push origin main    — отправить на сервер',
                code: true,
            },
            {
                heading: 'Получение изменений',
                body: 'ncore pull                — получить + слить с текущей веткой\nncore fetch               — получить без автослияния\nncore fetch --all         — получить все remote-ветки',
                code: true,
            },
            {
                heading: 'Ветки',
                body: 'ncore branch                   — список всех веток\nncore branch feature/auth      — создать новую ветку\nncore checkout feature/auth    — переключиться на ветку\nncore checkout -b hotfix/bug1  — создать и переключиться\nncore merge feature/auth       — слить ветку в текущую\nncore branch -d feature/auth   — удалить ветку',
                code: true,
            },
            {
                heading: 'История и сравнение',
                body: 'ncore log                  — история коммитов\nncore log --oneline        — краткая история\nncore diff                 — изменения в рабочей директории\nncore diff main..feature   — разница между ветками\nncore show <sha>           — показать конкретный коммит',
                code: true,
            },
            {
                heading: 'Удалённые репозитории',
                body: 'ncore remote -v                        — список remotes\nncore remote add origin <url>          — добавить remote\nncore remote set-url origin <новый_url> — изменить URL',
                code: true,
            },
        ],
    },
    {
        id: 'branches',
        title: 'Ветки',
        description: 'Управление ветками репозитория',
        items: [
            {
                heading: 'Основная ветка',
                body: 'При создании репозитория указывается основная ветка (по умолчанию: main). Она выделена в интерфейсе и защищена от случайного удаления.',
            },
            {
                heading: 'Переключение веток',
                body: 'На вкладке «Code» нажмите на имя текущей ветки в верхнем левом углу — откроется список всех веток репозитория для переключения.',
            },
            {
                heading: 'Защита веток',
                body: 'Владелец может включить защиту ветки. Защищённая ветка требует создания Pull Request для внесения изменений. Прямой ncore push в неё будет отклонён.',
            },
            {
                heading: 'Создание и удаление',
                body: 'Создавать и удалять ветки могут владелец и коллаборативы с уровнем доступа write или admin.',
            },
        ],
    },
    {
        id: 'issues',
        title: 'Issues',
        description: 'Трекинг задач, багов и предложений',
        items: [
            {
                heading: 'Создать Issue',
                body: 'Вкладка «Issues» → кнопка «Создать Issue».\nЗаполните: заголовок (обязательно), описание (Markdown-текст), тип (Bug / Feature / Question / Docs / Other), метки.',
            },
            {
                heading: 'Типы Issues',
                body: 'Bug — сообщение об ошибке\nFeature — предложение нового функционала\nQuestion — вопрос к разработчику\nDocs — улучшение документации\nOther — прочее',
            },
            {
                heading: 'Статусы',
                body: 'Open — открытая задача, требует внимания.\nClosed — закрыта (решена или отклонена).\nПереключать статус может только владелец репозитория и коллаборативы.',
            },
            {
                heading: 'Комментарии',
                body: 'Любой авторизованный пользователь может оставить комментарий. Комментарии — основной способ обсуждения задачи и отслеживания прогресса.',
            },
            {
                heading: 'Метки (labels)',
                body: 'Добавляйте метки через запятую для организации и фильтрации Issues.\nПример: priority:high, needs-review, blocked, v2.0',
            },
        ],
    },
    {
        id: 'pulls',
        title: 'Pull Requests',
        description: 'Запросы на слияние изменений',
        items: [
            {
                heading: 'Создать PR',
                body: 'Вкладка «Pull Requests» → «Создать PR».\nВыберите ветку-источник (head branch) и ветку-назначение (base branch). Добавьте заголовок и описание.',
            },
            {
                heading: 'Draft PR',
                body: 'Отметьте чекбокс «Draft» если изменения ещё не готовы к ревью. Draft PR нельзя слить до снятия флага.',
            },
            {
                heading: 'Статусы PR',
                body: 'Open — ожидает проверки и слияния\nMerged — изменения приняты и слиты в базовую ветку\nClosed — отклонён без слияния',
            },
            {
                heading: 'Слияние (Merge)',
                body: 'Только владелец репозитория может нажать «Merge». После слияния PR получает статус Merged. Ветка-источник может быть удалена вручную.',
            },
            {
                heading: 'Комментарии к файлам',
                body: 'При добавлении комментария к PR можно указать путь к файлу (file_path) и номер строки (line_number) для точной привязки комментария к коду.',
            },
        ],
    },
    {
        id: 'releases',
        title: 'Релизы',
        description: 'Версионирование и публикация',
        items: [
            {
                heading: 'Создать релиз',
                body: 'Вкладка «Releases» → «Создать релиз».\nУкажите: тег версии, заголовок, описание изменений (changelog). Выберите, является ли это пре-релизом.',
            },
            {
                heading: 'Семантическое версионирование',
                body: 'Рекомендуемый формат: v{MAJOR}.{MINOR}.{PATCH}\n\nv1.0.0 — первый стабильный релиз\nv1.1.0 — новые фичи без breaking changes\nv1.1.1 — исправление ошибок\nv2.0.0 — breaking changes',
                code: true,
            },
            {
                heading: 'Draft и Pre-release',
                body: 'Draft — черновик, виден только владельцу. Нажмите «Publish» для публикации.\nPre-release — помечается бейджем, означает нестабильную/тестовую версию.',
            },
            {
                heading: 'Удаление релиза',
                body: 'Владелец может удалить любой релиз. Тег при этом остаётся в репозитории. Опубликованные релизы рекомендуется не удалять из истории.',
            },
        ],
    },
    {
        id: 'wiki',
        title: 'Wiki',
        description: 'Документация проекта',
        items: [
            {
                heading: 'Что такое Wiki?',
                body: 'Wiki — раздел документации репозитория. Используйте для технической документации, API-гайдов, описания архитектуры, инструкций по установке и развёртыванию.',
            },
            {
                heading: 'Создание страниц',
                body: '1. Вкладка «Wiki» → «+ Добавить страницу»\n2. Введите заголовок страницы\n3. Напишите содержимое\n4. Нажмите «Сохранить»\n\nSlug генерируется автоматически из заголовка.',
            },
            {
                heading: 'Редактирование',
                body: 'Откройте страницу → кнопка «Редактировать». После внесения изменений нажмите «Сохранить». Редактировать могут авторизованные пользователи с доступом к репозиторию.',
            },
            {
                heading: 'Навигация',
                body: 'Левая панель Wiki содержит список всех страниц. Нажмите на название, чтобы открыть. Страница «Home» отображается первой по умолчанию.',
            },
        ],
    },
    {
        id: 'insights',
        title: 'Аналитика',
        description: 'Статистика и метрики репозитория',
        items: [
            {
                heading: 'Карточки статистики',
                body: 'В верхней части Insights отображаются 6 метрик:\n• Всего коммитов\n• Контрибьюторов\n• Открытых Issues\n• Закрытых Issues\n• Открытых PR\n• Слитых PR',
            },
            {
                heading: 'График активности',
                body: 'Гистограмма показывает количество коммитов за последние 30 дней. Высота столбцов масштабируется относительно максимального значения. Помогает отслеживать ритм разработки.',
            },
            {
                heading: 'Языки программирования',
                body: 'Цветная полоска с разбивкой по языкам. Рассчитывается на основе расширений файлов в репозитории. При наведении показывает процент и количество файлов.',
            },
            {
                heading: 'Рейтинг контрибьюторов',
                body: 'Список участников отсортирован по числу коммитов. Полоска прогресса показывает вклад относительно лидера. Включает владельца и всех коллаборативов совершивших коммиты.',
            },
        ],
    },
    {
        id: 'collab',
        title: 'Коллаборация',
        description: 'Совместная работа над репозиторием',
        items: [
            {
                heading: 'Добавить коллаборатива',
                body: 'В шапке репозитория нажмите «Collaborators» (видно только владельцу). Введите имя пользователя, выберите уровень доступа, нажмите «Добавить».',
            },
            {
                heading: 'Уровни доступа',
                body: 'Read — просмотр файлов, Issues, PR, Wiki.\nWrite — всё из Read + создание коммитов, Issues, PR, комментариев, страниц Wiki.\nAdmin — всё из Write + управление коллаборативами, настройки репозитория, удаление.',
            },
            {
                heading: 'Звёзды и форки',
                body: '⭐ Звезда — добавить в «Избранные». Счётчик отображается в карточке репозитория.\n🍴 Форк — создать копию репозитория в своём аккаунте. Счётчик форков показан в шапке.',
            },
            {
                heading: 'Приватность',
                body: 'Приватный репозиторий полностью скрыт от всех (включая список репозиториев) кроме владельца и коллаборативов. Измените статус на публичный в настройках репозитория.',
            },
        ],
    },
];

export default function HelpModal({ onClose }) {
    const [activeId, setActiveId] = useState('overview');
    const section = SECTIONS.find(s => s.id === activeId);

    return (
        <div className={styles.overlay} onClick={e => e.target === e.currentTarget && onClose()}>
            <div className={styles.modal}>
                {/* Header */}
                <div className={styles.header}>
                    <div className={styles.headerLeft}>
                        <div className={styles.headerIcon}>
                            <AigulIcon />
                        </div>
                        <div>
                            <h2 className={styles.headerTitle}>Справка NcoreHub</h2>
                            <p className={styles.headerSub}>Полная инструкция по использованию платформы</p>
                        </div>
                    </div>
                    <button className={styles.closeBtn} onClick={onClose} aria-label="Закрыть">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                        </svg>
                    </button>
                </div>

                {/* Body */}
                <div className={styles.body}>
                    {/* Navigation */}
                    <nav className={styles.nav}>
                        {SECTIONS.map(s => (
                            <button
                                key={s.id}
                                className={s.id === activeId ? styles.navItemActive : styles.navItem}
                                onClick={() => setActiveId(s.id)}
                            >
                                <span className={styles.navTitle}>{s.title}</span>
                                <span className={styles.navDesc}>{s.description}</span>
                            </button>
                        ))}
                    </nav>

                    {/* Content */}
                    <div className={styles.content}>
                        <div className={styles.contentHeader}>
                            <h3 className={styles.contentTitle}>{section.title}</h3>
                            <p className={styles.contentDesc}>{section.description}</p>
                        </div>
                        <div className={styles.items}>
                            {section.items.map((item, i) => (
                                <div key={i} className={styles.item}>
                                    <h4 className={styles.itemHeading}>{item.heading}</h4>
                                    {item.code ? (
                                        <pre className={styles.itemCode}>{item.body}</pre>
                                    ) : (
                                        <p className={styles.itemBody}>{item.body}</p>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
